module.exports = __webpack_public_path__ + "svg/comment.svg?1a3018a7bef2b4a421e784ab1503de12";